/* tslint:disable */
/* eslint-disable */
/**
 * Stacks Blockchain API
 * Welcome to the API reference overview for the [Stacks Blockchain API](https://docs.hiro.so/stacks-blockchain-api).  [Download Postman collection](https://hirosystems.github.io/stacks-blockchain-api/collection.json) 
 *
 * The version of the OpenAPI document: STACKS_API_VERSION
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ContractInterfaceResponse,
    ContractInterfaceResponseFromJSON,
    ContractInterfaceResponseToJSON,
    ContractListResponse,
    ContractListResponseFromJSON,
    ContractListResponseToJSON,
    ContractSourceResponse,
    ContractSourceResponseFromJSON,
    ContractSourceResponseToJSON,
    MapEntryResponse,
    MapEntryResponseFromJSON,
    MapEntryResponseToJSON,
    ReadOnlyFunctionArgs,
    ReadOnlyFunctionArgsFromJSON,
    ReadOnlyFunctionArgsToJSON,
    ReadOnlyFunctionSuccessResponse,
    ReadOnlyFunctionSuccessResponseFromJSON,
    ReadOnlyFunctionSuccessResponseToJSON,
    SmartContract,
    SmartContractFromJSON,
    SmartContractToJSON,
} from '../models';

export interface CallReadOnlyFunctionRequest {
    contractAddress: string;
    contractName: string;
    functionName: string;
    readOnlyFunctionArgs: ReadOnlyFunctionArgs;
    tip?: string;
}

export interface GetContractByIdRequest {
    contractId: string;
    unanchored?: boolean;
}

export interface GetContractDataMapEntryRequest {
    contractAddress: string;
    contractName: string;
    mapName: string;
    key: string;
    proof?: number;
    tip?: string;
}

export interface GetContractEventsByIdRequest {
    contractId: string;
    limit?: number;
    offset?: number;
    unanchored?: boolean;
}

export interface GetContractInterfaceRequest {
    contractAddress: string;
    contractName: string;
    tip?: string;
}

export interface GetContractSourceRequest {
    contractAddress: string;
    contractName: string;
    proof?: number;
    tip?: string;
}

export interface GetContractsByTraitRequest {
    traitAbi: string;
    limit?: number;
    offset?: number;
}

export interface GetSmartContractsStatusRequest {
    contractId: Array<string>;
}

/**
 * SmartContractsApi - interface
 * 
 * @export
 * @interface SmartContractsApiInterface
 */
export interface SmartContractsApiInterface {
    /**
     * Call a read-only public function on a given smart contract.  The smart contract and function are specified using the URL path. The arguments and the simulated tx-sender are supplied via the POST body in the following JSON format: 
     * @summary Call read-only function
     * @param {string} contractAddress Stacks address
     * @param {string} contractName Contract name
     * @param {string} functionName Function name
     * @param {ReadOnlyFunctionArgs} readOnlyFunctionArgs 
     * @param {string} [tip] The Stacks chain tip to query from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmartContractsApiInterface
     */
    callReadOnlyFunctionRaw(requestParameters: CallReadOnlyFunctionRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ReadOnlyFunctionSuccessResponse>>;

    /**
     * Call a read-only public function on a given smart contract.  The smart contract and function are specified using the URL path. The arguments and the simulated tx-sender are supplied via the POST body in the following JSON format: 
     * Call read-only function
     */
    callReadOnlyFunction(requestParameters: CallReadOnlyFunctionRequest, initOverrides?: RequestInit): Promise<ReadOnlyFunctionSuccessResponse>;

    /**
     * Retrieves details of a contract with a given `contract_id`
     * @summary Get contract info
     * @param {string} contractId Contract identifier formatted as &#x60;&lt;contract_address&gt;.&lt;contract_name&gt;&#x60;
     * @param {boolean} [unanchored] Include transaction data from unanchored (i.e. unconfirmed) microblocks
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmartContractsApiInterface
     */
    getContractByIdRaw(requestParameters: GetContractByIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SmartContract>>;

    /**
     * Retrieves details of a contract with a given `contract_id`
     * Get contract info
     */
    getContractById(requestParameters: GetContractByIdRequest, initOverrides?: RequestInit): Promise<SmartContract>;

    /**
     * Attempt to fetch data from a contract data map. The contract is identified with Stacks Address `contract_address` and Contract Name `contract_address` in the URL path. The map is identified with [Map Name].  The key to lookup in the map is supplied via the POST body. This should be supplied as the hex string serialization of the key (which should be a Clarity value). Note, this is a JSON string atom.  In the response, `data` is the hex serialization of the map response. Note that map responses are Clarity option types, for non-existent values, this is a serialized none, and for all other responses, it is a serialized (some ...) object. 
     * @summary Get specific data-map inside a contract
     * @param {string} contractAddress Stacks address
     * @param {string} contractName Contract name
     * @param {string} mapName Map name
     * @param {string} key Hex string serialization of the lookup key (which should be a Clarity value)
     * @param {number} [proof] Returns object without the proof field when set to 0
     * @param {string} [tip] The Stacks chain tip to query from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmartContractsApiInterface
     */
    getContractDataMapEntryRaw(requestParameters: GetContractDataMapEntryRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<MapEntryResponse>>;

    /**
     * Attempt to fetch data from a contract data map. The contract is identified with Stacks Address `contract_address` and Contract Name `contract_address` in the URL path. The map is identified with [Map Name].  The key to lookup in the map is supplied via the POST body. This should be supplied as the hex string serialization of the key (which should be a Clarity value). Note, this is a JSON string atom.  In the response, `data` is the hex serialization of the map response. Note that map responses are Clarity option types, for non-existent values, this is a serialized none, and for all other responses, it is a serialized (some ...) object. 
     * Get specific data-map inside a contract
     */
    getContractDataMapEntry(requestParameters: GetContractDataMapEntryRequest, initOverrides?: RequestInit): Promise<MapEntryResponse>;

    /**
     * Retrieves a list of events that have been triggered by a given `contract_id`
     * @summary Get contract events
     * @param {string} contractId Contract identifier formatted as &#x60;&lt;contract_address&gt;.&lt;contract_name&gt;&#x60;
     * @param {number} [limit] max number of contract events to fetch
     * @param {number} [offset] index of first contract event to fetch
     * @param {boolean} [unanchored] Include transaction data from unanchored (i.e. unconfirmed) microblocks
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmartContractsApiInterface
     */
    getContractEventsByIdRaw(requestParameters: GetContractEventsByIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<object>>;

    /**
     * Retrieves a list of events that have been triggered by a given `contract_id`
     * Get contract events
     */
    getContractEventsById(requestParameters: GetContractEventsByIdRequest, initOverrides?: RequestInit): Promise<object>;

    /**
     * Retrieves a contract interface with a given `contract_address` and `contract name`
     * @summary Get contract interface
     * @param {string} contractAddress Stacks address
     * @param {string} contractName Contract name
     * @param {string} [tip] The Stacks chain tip to query from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmartContractsApiInterface
     */
    getContractInterfaceRaw(requestParameters: GetContractInterfaceRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ContractInterfaceResponse>>;

    /**
     * Retrieves a contract interface with a given `contract_address` and `contract name`
     * Get contract interface
     */
    getContractInterface(requestParameters: GetContractInterfaceRequest, initOverrides?: RequestInit): Promise<ContractInterfaceResponse>;

    /**
     * Retrieves the Clarity source code of a given contract, along with the block height it was published in, and the MARF proof for the data
     * @summary Get contract source
     * @param {string} contractAddress Stacks address
     * @param {string} contractName Contract name
     * @param {number} [proof] Returns object without the proof field if set to 0
     * @param {string} [tip] The Stacks chain tip to query from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmartContractsApiInterface
     */
    getContractSourceRaw(requestParameters: GetContractSourceRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ContractSourceResponse>>;

    /**
     * Retrieves the Clarity source code of a given contract, along with the block height it was published in, and the MARF proof for the data
     * Get contract source
     */
    getContractSource(requestParameters: GetContractSourceRequest, initOverrides?: RequestInit): Promise<ContractSourceResponse>;

    /**
     * Retrieves a list of contracts based on the following traits listed in JSON format -  functions, variables, maps, fungible tokens and non-fungible tokens
     * @summary Get contracts by trait
     * @param {string} traitAbi JSON abi of the trait.
     * @param {number} [limit] max number of contracts fetch
     * @param {number} [offset] index of first contract event to fetch
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmartContractsApiInterface
     */
    getContractsByTraitRaw(requestParameters: GetContractsByTraitRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ContractListResponse>>;

    /**
     * Retrieves a list of contracts based on the following traits listed in JSON format -  functions, variables, maps, fungible tokens and non-fungible tokens
     * Get contracts by trait
     */
    getContractsByTrait(requestParameters: GetContractsByTraitRequest, initOverrides?: RequestInit): Promise<ContractListResponse>;

    /**
     * Retrieves the deployment status of multiple smart contracts. 
     * @summary Get smart contracts status
     * @param {Array<string>} contractId contract ids to fetch status for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmartContractsApiInterface
     */
    getSmartContractsStatusRaw(requestParameters: GetSmartContractsStatusRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<{ [key: string]: object; }>>;

    /**
     * Retrieves the deployment status of multiple smart contracts. 
     * Get smart contracts status
     */
    getSmartContractsStatus(requestParameters: GetSmartContractsStatusRequest, initOverrides?: RequestInit): Promise<{ [key: string]: object; }>;

}

/**
 * 
 */
export class SmartContractsApi extends runtime.BaseAPI implements SmartContractsApiInterface {

    /**
     * Call a read-only public function on a given smart contract.  The smart contract and function are specified using the URL path. The arguments and the simulated tx-sender are supplied via the POST body in the following JSON format: 
     * Call read-only function
     */
    async callReadOnlyFunctionRaw(requestParameters: CallReadOnlyFunctionRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ReadOnlyFunctionSuccessResponse>> {
        if (requestParameters.contractAddress === null || requestParameters.contractAddress === undefined) {
            throw new runtime.RequiredError('contractAddress','Required parameter requestParameters.contractAddress was null or undefined when calling callReadOnlyFunction.');
        }

        if (requestParameters.contractName === null || requestParameters.contractName === undefined) {
            throw new runtime.RequiredError('contractName','Required parameter requestParameters.contractName was null or undefined when calling callReadOnlyFunction.');
        }

        if (requestParameters.functionName === null || requestParameters.functionName === undefined) {
            throw new runtime.RequiredError('functionName','Required parameter requestParameters.functionName was null or undefined when calling callReadOnlyFunction.');
        }

        if (requestParameters.readOnlyFunctionArgs === null || requestParameters.readOnlyFunctionArgs === undefined) {
            throw new runtime.RequiredError('readOnlyFunctionArgs','Required parameter requestParameters.readOnlyFunctionArgs was null or undefined when calling callReadOnlyFunction.');
        }

        const queryParameters: any = {};

        if (requestParameters.tip !== undefined) {
            queryParameters['tip'] = requestParameters.tip;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v2/contracts/call-read/{contract_address}/{contract_name}/{function_name}`.replace(`{${"contract_address"}}`, encodeURIComponent(String(requestParameters.contractAddress))).replace(`{${"contract_name"}}`, encodeURIComponent(String(requestParameters.contractName))).replace(`{${"function_name"}}`, encodeURIComponent(String(requestParameters.functionName))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReadOnlyFunctionArgsToJSON(requestParameters.readOnlyFunctionArgs),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReadOnlyFunctionSuccessResponseFromJSON(jsonValue));
    }

    /**
     * Call a read-only public function on a given smart contract.  The smart contract and function are specified using the URL path. The arguments and the simulated tx-sender are supplied via the POST body in the following JSON format: 
     * Call read-only function
     */
    async callReadOnlyFunction(requestParameters: CallReadOnlyFunctionRequest, initOverrides?: RequestInit): Promise<ReadOnlyFunctionSuccessResponse> {
        const response = await this.callReadOnlyFunctionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves details of a contract with a given `contract_id`
     * Get contract info
     */
    async getContractByIdRaw(requestParameters: GetContractByIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SmartContract>> {
        if (requestParameters.contractId === null || requestParameters.contractId === undefined) {
            throw new runtime.RequiredError('contractId','Required parameter requestParameters.contractId was null or undefined when calling getContractById.');
        }

        const queryParameters: any = {};

        if (requestParameters.unanchored !== undefined) {
            queryParameters['unanchored'] = requestParameters.unanchored;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/extended/v1/contract/{contract_id}`.replace(`{${"contract_id"}}`, encodeURIComponent(String(requestParameters.contractId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SmartContractFromJSON(jsonValue));
    }

    /**
     * Retrieves details of a contract with a given `contract_id`
     * Get contract info
     */
    async getContractById(requestParameters: GetContractByIdRequest, initOverrides?: RequestInit): Promise<SmartContract> {
        const response = await this.getContractByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Attempt to fetch data from a contract data map. The contract is identified with Stacks Address `contract_address` and Contract Name `contract_address` in the URL path. The map is identified with [Map Name].  The key to lookup in the map is supplied via the POST body. This should be supplied as the hex string serialization of the key (which should be a Clarity value). Note, this is a JSON string atom.  In the response, `data` is the hex serialization of the map response. Note that map responses are Clarity option types, for non-existent values, this is a serialized none, and for all other responses, it is a serialized (some ...) object. 
     * Get specific data-map inside a contract
     */
    async getContractDataMapEntryRaw(requestParameters: GetContractDataMapEntryRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<MapEntryResponse>> {
        if (requestParameters.contractAddress === null || requestParameters.contractAddress === undefined) {
            throw new runtime.RequiredError('contractAddress','Required parameter requestParameters.contractAddress was null or undefined when calling getContractDataMapEntry.');
        }

        if (requestParameters.contractName === null || requestParameters.contractName === undefined) {
            throw new runtime.RequiredError('contractName','Required parameter requestParameters.contractName was null or undefined when calling getContractDataMapEntry.');
        }

        if (requestParameters.mapName === null || requestParameters.mapName === undefined) {
            throw new runtime.RequiredError('mapName','Required parameter requestParameters.mapName was null or undefined when calling getContractDataMapEntry.');
        }

        if (requestParameters.key === null || requestParameters.key === undefined) {
            throw new runtime.RequiredError('key','Required parameter requestParameters.key was null or undefined when calling getContractDataMapEntry.');
        }

        const queryParameters: any = {};

        if (requestParameters.proof !== undefined) {
            queryParameters['proof'] = requestParameters.proof;
        }

        if (requestParameters.tip !== undefined) {
            queryParameters['tip'] = requestParameters.tip;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v2/map_entry/{contract_address}/{contract_name}/{map_name}`.replace(`{${"contract_address"}}`, encodeURIComponent(String(requestParameters.contractAddress))).replace(`{${"contract_name"}}`, encodeURIComponent(String(requestParameters.contractName))).replace(`{${"map_name"}}`, encodeURIComponent(String(requestParameters.mapName))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.key as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MapEntryResponseFromJSON(jsonValue));
    }

    /**
     * Attempt to fetch data from a contract data map. The contract is identified with Stacks Address `contract_address` and Contract Name `contract_address` in the URL path. The map is identified with [Map Name].  The key to lookup in the map is supplied via the POST body. This should be supplied as the hex string serialization of the key (which should be a Clarity value). Note, this is a JSON string atom.  In the response, `data` is the hex serialization of the map response. Note that map responses are Clarity option types, for non-existent values, this is a serialized none, and for all other responses, it is a serialized (some ...) object. 
     * Get specific data-map inside a contract
     */
    async getContractDataMapEntry(requestParameters: GetContractDataMapEntryRequest, initOverrides?: RequestInit): Promise<MapEntryResponse> {
        const response = await this.getContractDataMapEntryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a list of events that have been triggered by a given `contract_id`
     * Get contract events
     */
    async getContractEventsByIdRaw(requestParameters: GetContractEventsByIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<object>> {
        if (requestParameters.contractId === null || requestParameters.contractId === undefined) {
            throw new runtime.RequiredError('contractId','Required parameter requestParameters.contractId was null or undefined when calling getContractEventsById.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.unanchored !== undefined) {
            queryParameters['unanchored'] = requestParameters.unanchored;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/extended/v1/contract/{contract_id}/events`.replace(`{${"contract_id"}}`, encodeURIComponent(String(requestParameters.contractId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieves a list of events that have been triggered by a given `contract_id`
     * Get contract events
     */
    async getContractEventsById(requestParameters: GetContractEventsByIdRequest, initOverrides?: RequestInit): Promise<object> {
        const response = await this.getContractEventsByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a contract interface with a given `contract_address` and `contract name`
     * Get contract interface
     */
    async getContractInterfaceRaw(requestParameters: GetContractInterfaceRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ContractInterfaceResponse>> {
        if (requestParameters.contractAddress === null || requestParameters.contractAddress === undefined) {
            throw new runtime.RequiredError('contractAddress','Required parameter requestParameters.contractAddress was null or undefined when calling getContractInterface.');
        }

        if (requestParameters.contractName === null || requestParameters.contractName === undefined) {
            throw new runtime.RequiredError('contractName','Required parameter requestParameters.contractName was null or undefined when calling getContractInterface.');
        }

        const queryParameters: any = {};

        if (requestParameters.tip !== undefined) {
            queryParameters['tip'] = requestParameters.tip;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v2/contracts/interface/{contract_address}/{contract_name}`.replace(`{${"contract_address"}}`, encodeURIComponent(String(requestParameters.contractAddress))).replace(`{${"contract_name"}}`, encodeURIComponent(String(requestParameters.contractName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContractInterfaceResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a contract interface with a given `contract_address` and `contract name`
     * Get contract interface
     */
    async getContractInterface(requestParameters: GetContractInterfaceRequest, initOverrides?: RequestInit): Promise<ContractInterfaceResponse> {
        const response = await this.getContractInterfaceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the Clarity source code of a given contract, along with the block height it was published in, and the MARF proof for the data
     * Get contract source
     */
    async getContractSourceRaw(requestParameters: GetContractSourceRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ContractSourceResponse>> {
        if (requestParameters.contractAddress === null || requestParameters.contractAddress === undefined) {
            throw new runtime.RequiredError('contractAddress','Required parameter requestParameters.contractAddress was null or undefined when calling getContractSource.');
        }

        if (requestParameters.contractName === null || requestParameters.contractName === undefined) {
            throw new runtime.RequiredError('contractName','Required parameter requestParameters.contractName was null or undefined when calling getContractSource.');
        }

        const queryParameters: any = {};

        if (requestParameters.proof !== undefined) {
            queryParameters['proof'] = requestParameters.proof;
        }

        if (requestParameters.tip !== undefined) {
            queryParameters['tip'] = requestParameters.tip;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v2/contracts/source/{contract_address}/{contract_name}`.replace(`{${"contract_address"}}`, encodeURIComponent(String(requestParameters.contractAddress))).replace(`{${"contract_name"}}`, encodeURIComponent(String(requestParameters.contractName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContractSourceResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves the Clarity source code of a given contract, along with the block height it was published in, and the MARF proof for the data
     * Get contract source
     */
    async getContractSource(requestParameters: GetContractSourceRequest, initOverrides?: RequestInit): Promise<ContractSourceResponse> {
        const response = await this.getContractSourceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a list of contracts based on the following traits listed in JSON format -  functions, variables, maps, fungible tokens and non-fungible tokens
     * Get contracts by trait
     */
    async getContractsByTraitRaw(requestParameters: GetContractsByTraitRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ContractListResponse>> {
        if (requestParameters.traitAbi === null || requestParameters.traitAbi === undefined) {
            throw new runtime.RequiredError('traitAbi','Required parameter requestParameters.traitAbi was null or undefined when calling getContractsByTrait.');
        }

        const queryParameters: any = {};

        if (requestParameters.traitAbi !== undefined) {
            queryParameters['trait_abi'] = requestParameters.traitAbi;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/extended/v1/contract/by_trait`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContractListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a list of contracts based on the following traits listed in JSON format -  functions, variables, maps, fungible tokens and non-fungible tokens
     * Get contracts by trait
     */
    async getContractsByTrait(requestParameters: GetContractsByTraitRequest, initOverrides?: RequestInit): Promise<ContractListResponse> {
        const response = await this.getContractsByTraitRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the deployment status of multiple smart contracts. 
     * Get smart contracts status
     */
    async getSmartContractsStatusRaw(requestParameters: GetSmartContractsStatusRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<{ [key: string]: object; }>> {
        if (requestParameters.contractId === null || requestParameters.contractId === undefined) {
            throw new runtime.RequiredError('contractId','Required parameter requestParameters.contractId was null or undefined when calling getSmartContractsStatus.');
        }

        const queryParameters: any = {};

        if (requestParameters.contractId) {
            queryParameters['contract_id'] = requestParameters.contractId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/extended/v2/smart-contracts/status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieves the deployment status of multiple smart contracts. 
     * Get smart contracts status
     */
    async getSmartContractsStatus(requestParameters: GetSmartContractsStatusRequest, initOverrides?: RequestInit): Promise<{ [key: string]: object; }> {
        const response = await this.getSmartContractsStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
